export const COMPANY_INFO = {
    name: "UNITED MOTORS",
    tagline: "PREMIUM AUTOMOBILE SOLUTIONS & SERVICES",
    address: "Plot #12, Rawalpindi, Pakistan",
    phone: "+92 51 1234567",
    email: "info@unitedmotors.com.pk",
    ntn: "1234567-8",
    strn: "987654321",
    website: "www.unitedmotors.com.pk",
    footerNote: "This is a computer-generated official accounting document."
};